import { render, staticRenderFns } from "./PlosP_List.vue?vue&type=template&id=56ecaa39"
import script from "./PlosP_List.vue?vue&type=script&lang=js"
export * from "./PlosP_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports